export default __webpack_public_path__ + "static/media/Google_Logo.3cec7ff9.svg";